import { useEffect } from 'react';

import { Subscriptions } from '@mint-lib/api-sdk/emails';
import { Checkmark, Information } from '@mint-lib/icons';
import {
  Card,
  FeaturedIcon,
  typographyVariants,
} from '@mint-lib/tw-components';
import { getRouteApi } from '@mint/emails-routing';

const routeApi = getRouteApi('/recommendation/unsubscribe');

function UnsubscribeRouteComponent() {
  const search = routeApi.useSearch();
  const { mutate } = Subscriptions.unsubscribe();
  useEffect(() => {
    mutate({ params: { token: search.token } });
  }, [mutate, search.token]);

  return (
    <Card
      hover={'noHover'}
      className="flex h-[50vh] w-212.5 items-center justify-center overflow-hidden px-13"
      contentClassName="p-0"
    >
      <div className={'flex flex-col items-center justify-center gap-8'}>
        <div className={'flex flex-col items-center justify-center gap-4'}>
          <FeaturedIcon icon={<Checkmark />} className={'h-16 w-16'} />
          <h2
            className={typographyVariants({ variant: 'h2', color: 'primary' })}
          >
            Unsubscribed
          </h2>
        </div>
        <p
          className={typographyVariants({
            variant: 'bodyLong02',
            color: 'secondary',
          })}
        >
          You've been successfully unsubscribed from AIRE's budget
          recommendations on MINT Enterprise
        </p>
        <div className="flex">
          <Information className="fill-icon-secondary" />
          <p
            className={typographyVariants({
              variant: 'caption1',
              color: 'secondary',
              className: 'ml-1',
            })}
          >
            If you'd like to delete all of your user data according to GDPR
            policy, please send an email to privacy@mint.ai
          </p>
        </div>
      </div>
    </Card>
  );
}

export default UnsubscribeRouteComponent;
